module.exports = __webpack_public_path__ + "static/media/bw.5e96c253.svg";